<template>
  <div>
    <button
      type="button"
      class="rounded-[0.7rem] text-sm font-bold items-center bg-jm_white py-[0.66rem] w-[18rem]"
      @click="handleButtonClick"
    >
      GOT IT
    </button>
  </div>
</template>
<script lang="ts" setup>
import { useGlobalStore } from "../stores/global";
import { useGameTracking } from "@/composables/useGameTracking";

const globalStore = useGlobalStore();
const { kpiTracker } = useGameTracking();

const handleButtonClick = () => {
  globalStore.changeStep("ageCheck");
  globalStore.playTapSound();
  kpiTracker.resetGame();
  kpiTracker.resetTrackingData();
  globalStore.resetGame(kpiTracker.selectedPerson.value);
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/main.sass";
</style>
